export const list = [
  {
    assetId: 2204,
    name: 'GMV - BRL5491',
    id: 1168,
    type: 'MOTORCYCLE',
    subType: '1 tonne',
    brand: 'Alfa Romeo',
    model: 'xx',
    class: '1',
    create_time: '10/01/2024 | 17:25:26',
  },
  {
    assetId: 5,
    name: 'SKTS - SYB7170 IGT Test',
    id: 1169,
    type: 'CAR',
    subType: 'Van',
    brand: 'Aston Martin',
    model: 'asdas',
    class: '1',
    create_time: '15/01/2024 | 16:11:36',
  },
  {
    assetId: 1657,
    name: '844744',
    id: 1173,
    type: 'LORRY/TRUCK',
    subType:
      '{"label": "Prime Movers 1", "value": 6, "backTire": "2", "frontTire": "1", "middleTire": "1", "backTirePair": "Pair", "frontTirePair": "Single", "middleTirePair": "Pair"}',
    brand: 'Alfa Romeo',
    model: 'xx',
    class: '2',
    create_time: '22/01/2024 | 19:26:40',
  },
];

export const base = {
  fleetInfo: {
    type: 'MOTORCYCLE',
    brand: 'Alfa Romeo',
    class: {
      text: 'Class 1 (Motorcycles)',
      value: 1,
    },
    model: 'xx',
    plate: 'GMV - BRL5491',
    assetId: 2204,
    subType: '1 tonne',
    industry: ['Personal Usage'],
    vehicleImages: [
      'doc_1704880578654_1421245872_Playback-Map.jpg',
      'doc_1704880595327_5052259638_Playback-Map.jpg',
      'doc_1704880598542_5907670601_Playback-Map.jpg',
      'doc_1706457868508_2810005753_test.plugin.json',
    ],
  },
  fleetAlarm: [
    {
      cost: 0,
      date: '2024-01-17',
      type: 'Permit',
      remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
      mileage: '',
      documents: ['doc_1709284802223_5031870303_code.png'],
    },
  ],
  fleetConfig: {
    tank1: 450,
    tank2: 450,
    mileage: 45987,
    backTire: 3,
    frontTire: '1',
    tankCount: '2',
    fuelSensor: true,
    middleTire: 4,
    baseTracker: true,
    backTirePair: 'Pair',
    frontTirePair: 'Single',
    middleTirePair: 'Single',
    temperatureSensor: false,
  },
  fleetMaintenance: [
    {
      cost: 0,
      date: '',
      type: 'CV Joints',
      notif: false,
      remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
      mileage: '989898',
      subtype: '',
      documents: [],
    },
  ],
  fleetTireListing: [
    {
      brand: '',
      model: '',
      pincode: '',
      remarks: '',
      position: 'FL1',
      reminders: [],
      purchaseData: '2024-01-10',
      purchaseDate: '',
      purchasePrice: 0,
      selectedIndex: 0,
      purchaseStatus: 'CELUP',
    },
  ],
  fleetTireHistory: [],
  fleetRecordHistory: [
    {
      cost: 0,
      date: '2024-01-16',
      type: '',
      cDate: '2024-01-15',
      mType: 'Document',
      remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
      mileage: '',
      documents: [],
    },
    {
      cost: '-1',
      date: '2024-01-11',
      type: 'Road Tax',
      cDate: '2024-02-29',
      mType: 'Document',
      remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
      mileage: '',
      documents: ['doc_1705131162762_2115707551_island-8006762_1280.webp'],
    },
  ],
  tireNotificationConfig: [500, 200, 100],
  docNotificationConfig: ['1', '0', '0'],
  fleetNotificationConfig: [30, 14, 3],
  fleetNotification: [
    {
      mode: ['All'],
      type: 'Telegram',
      detail: '',
      remark: '',
    },
    {
      mode: ['All'],
      type: '',
      detail: '',
      remark: '',
    },
    {
      mode: ['All'],
      type: '',
      detail: '',
      remark: '',
    },
  ],
};
export const emptyBase = {
  fleetInfo: {},
  fleetAlarm: [],
  fleetConfig: {},
  fleetMaintenance: [],
  fleetTireListing: [],
  fleetTireHistory: [],
  fleetRecordHistory: [],
  tireNotificationConfig: [],
  docNotificationConfig: [],
  fleetNotificationConfig: [],
  fleetNotification: [],
};

export const detail = {
  success: 'FMS Record retrieved!',
  fleetDetails: {
    id: 1168,
    assetId: 2204,
    userInfo: {
      api: 'v2.0',
      fms: false,
      uid: 338,
      immo: false,
      email: 'aleng@aleng.com',
      access: {
        name: 'IGT Staff',
        pages: [
          'mapview',
          'tableview',
          'hybridview',
          'multiview',
          'playback',
          'tms',
          'fms',
          'reports',
        ],
        users: [331, 330, 329, 231, 303],
        actions: [
          'immo-on',
          'immo-off',
          'poi-add',
          'poi-delete',
          'poi-alarms',
          'events-staff',
        ],
        reports: [
          'Alarm',
          'Fuel',
          'History',
          'Input',
          'Mileage',
          'Notification',
          'Summary',
          'Temperature',
          'Fuel Receipt',
          'Maintenance Log',
          'Tire Cost Analysis',
          'Fatigue Driving'
        ],
        createdBy: 'igeotech',
        createdById: 1,
      },
      groups: '169,243,229,36,210',
      indies: '5,2205,2204,2172,1657,2206',
      company: 'Sunrise Tech Ventures Sdn Bhd',
      mapType: 'standard',
      showPOI: true,
      userRole: 'Client',
      username: 'aleng',
      fuelPrice: 2.15,
      help_call: '60192185482',
      streetview: false,
      accessToken: 'sF9_QLWqjt',
      displayName: 'AlIff Sunrise Tech',
      logo_big_url:
        'https://api.igeotechgps.com/uploads/doc_1701883160171_9643081654_39217597.png',
      help_whatsapp: '60192185482',
      notifications: true,
      logo_small_url:
        'https://api.igeotechgps.com/uploads/doc_1701883155959_7599937038_39217597.png',
    },
    fleetInfo: {
      type: 'MOTORCYCLE',
      brand: 'Alfa Romeo',
      class: {
        text: 'Class 1 (Motorcycles)',
        value: 1,
      },
      model: 'xx',
      plate: 'GMV - BRL5491',
      assetId: 2204,
      subType: '1 tonne',
      industry: ['Personal Usage'],
      vehicleImages: [
        'doc_1704880578654_1421245872_Playback-Map.jpg',
        'doc_1704880595327_5052259638_Playback-Map.jpg',
        'doc_1704880598542_5907670601_Playback-Map.jpg',
        'doc_1706457868508_2810005753_test.plugin.json',
      ],
    },
    fleetAlarm: [
      {
        cost: 0,
        date: '2024-01-17',
        type: 'Permit',
        remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
        mileage: '',
        documents: ['doc_1709284802223_5031870303_code.png'],
      },
    ],
    fleetConfig: {
      tank1: 450,
      tank2: 450,
      mileage: 45987,
      backTire: 3,
      frontTire: '1',
      tankCount: '2',
      fuelSensor: true,
      middleTire: 4,
      baseTracker: true,
      backTirePair: 'Pair',
      frontTirePair: 'Single',
      middleTirePair: 'Single',
      temperatureSensor: false,
    },
    fleetMaintenance: [
      {
        cost: 0,
        date: '',
        type: 'CV Joints',
        notif: false,
        remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
        mileage: '989898',
        subtype: '',
        documents: [],
      },
    ],
    fleetTireListing: [
      {
        brand: '',
        model: '',
        pincode: '',
        remarks: '',
        position: 'FL1',
        reminders: [],
        purchaseData: '2024-01-10',
        purchaseDate: '',
        purchasePrice: 0,
        selectedIndex: 0,
        purchaseStatus: 'CELUP',
      },
    ],
    fleetTireHistory: [],
    fleetRecordHistory: [
      {
        cost: 0,
        date: '2024-01-16',
        type: '',
        cDate: '2024-01-15',
        mType: 'Document',
        remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
        mileage: '',
        documents: [],
      },
      {
        cost: '-1',
        date: '2024-01-11',
        type: 'Road Tax',
        cDate: '2024-02-29',
        mType: 'Document',
        remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
        mileage: '',
        documents: ['doc_1705131162762_2115707551_island-8006762_1280.webp'],
      },
    ],
    tireNotificationConfig: [500, 200, 100],
    docNotificationConfig: ['1', '0', '0'],
    fleetNotificationConfig: [30, 14, 3],
    fleetNotification: [
      {
        mode: ['All'],
        type: 'Telegram',
        detail: '',
        remark: '',
      },
      {
        mode: ['All'],
        type: '',
        detail: '',
        remark: '',
      },
      {
        mode: ['All'],
        type: '',
        detail: '',
        remark: '',
      },
    ],
    status: null,
    create_time: '2024-01-10T09:25:26.000Z',
    update_time: '2024-03-01T09:20:33.000Z',
  },
  upcomingReminders: [
    {
      cost: 0,
      date: '',
      type: 'CV Joints',
      notif: false,
      remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
      mileage: '989898',
      subtype: '',
      documents: [],
      diffInDays: -1,
      notifType: 'Final reminder [Mileage]',
      docDateFormatted: 'Invalid date',
      mileageExpiry: true,
      currentMileage: 45987,
    },
  ],
  currentMileage: 45987,
  tireAlarms: [
    {
      brand: '',
      model: '',
      pincode: '',
      remarks: '',
      position: 'FL1',
      reminders: [],
      purchaseData: '2024-01-10',
      purchaseDate: '',
      purchasePrice: 0,
      selectedIndex: 0,
      purchaseStatus: 'CELUP',
    },
  ],
};
